import { Routes } from '@angular/router';
import {
  authGuard,
  gymRequiredGuard,
  specialInterestGuard,
} from '@core/guards';
import { LayoutComponent } from '@layout/layout.component';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./routes/login/login.routes').then(m => m.routes),
  },
  {
    path: 'survey',
    loadChildren: () =>
      import('./routes/public/survey/survey.routes').then(m => m.routes),
  },
  {
    path: 'contractProposal',
    loadChildren: () =>
      import('./routes/public/contract-proposal/contract-proposal.routes').then(
        m => m.routes
      ),
  },
  {
    path: 'registerClub',
    loadChildren: () =>
      import(
        './routes/public/community-club-registration/community-club-registration.routes'
      ).then(m => m.routes),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('./routes/customers/customers.routes').then(m => m.routes),
      },
      {
        path: 'error',
        loadChildren: () =>
          import('./routes/error/error.routes').then(m => m.routes),
      },
      {
        path: 'dashboard',
        canActivate: [gymRequiredGuard],
        loadChildren: () =>
          import('./routes/dashboard/dashboard.routes').then(m => m.routes),
      },
      {
        path: 'gym-management',
        canActivate: [gymRequiredGuard],
        loadChildren: () =>
          import('./routes/gym-management/gym-management.routes').then(
            m => m.routes
          ),
      },
      {
        path: 'event-management',
        canActivate: [specialInterestGuard],
        loadChildren: () =>
          import('./routes/event-managment/event-management.routes').then(
            m => m.routes
          ),
      },
      {
        path: 'community-management',
        loadChildren: () =>
          import(
            './routes/community-management/community-management.routes'
          ).then(m => m.routes),
      },
      {
        path: 'messages',
        loadChildren: () =>
          import('./routes/messages/messages.routes').then(m => m.routes),
      },
      {
        path: 'training-sessions',
        canActivate: [gymRequiredGuard],
        loadChildren: () =>
          import('./routes/training-sessions/training-sessions.routes').then(
            m => m.routes
          ),
      },
      {
        path: 'marketing',
        loadChildren: () =>
          import('./routes/marketing/marketing.routes').then(m => m.routes),
      },
      {
        path: 'help-center',
        loadChildren: () =>
          import('./routes/help-center/help-center.routes').then(m => m.routes),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./routes/settings/settings.routes').then(m => m.routes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
